export enum MeetingCategoryEnum {
  MEETING = 'MEETING',
  EVENT = 'EVENT'
}
